import { PALETTE } from '../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        root: {
            paddingLeft: '20px',
        },
        selectedSubscription: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            },
        },
        subscription: {
            display: 'flex',
            flex: 1,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            },
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        dayRowLabel: {
            // alignItems: 'flex-end',
            alignItems: 'baseline',
            marginTop: '4px',
            display: 'flex'
        },
        dayIsDisabled: {
            backgroundColor: '#E85B4A',
            borderBottom: '1px solid #000'
        },
        dayIsEnabled: {
            backgroundColor: '#52FF6D',
            borderBottom: '1px solid #000'
        },
        listSubheaderContainer: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        listSubheader: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        checkedred: {
            backgroundColor: "#ff0000",
            color: "white",
        },
        checkedorange: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        checkedorangelt: {
            backgroundColor: "#fcdbbb",
            color: "#ff6600",
        },
    }
}